module.exports = __webpack_public_path__ + "static/img/7.6d17295.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/7.png
// module id = 4Mu2
// module chunks = 0